import React, { useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'; 
import Testimonials from '../Testimonials';
import Who from '../Who';
import Group from '../Group';
import What from '../What';
import Services from '../Services';
import Contact from '../Contact';
import { AppContext } from '../../contexts/AppContext';
import mainLogo from '../../images/plan-a-media-group.png';

export default function Contents() {
  const { useMobileView } = useContext(AppContext);

  const [showButton, setShowButton] = useState(false);

  const backToTopBtnDesktop = {
    backgroundColor: 'red',
    color: 'white',
    '&:hover': {
      backgroundColor: '#9b0000',
    }
  };

  const backToTopBtnMobile = {
    width: 52,
    height: 52,
    backgroundColor: 'red',
    color: 'white',
    '&:hover': {
      backgroundColor: '#9b0000',
    },
  };

  const backToTopIconMobile = {
    fontSize: 36,
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 200) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    })
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    window.location.hash = '';
  };

  return (
    <>
      <Grid
        container
        spacing={3}
        sx={{
          padding: '16px 16px',
          margin: '0px 0px',
          width: '100%',
        }}
        id="top"
      >
        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          sx={{
            paddingRight: '16px',
            paddingBottom: '16px',
          }}

        >
          <Typography
            sx={{
              fontSize: '1.5em',
              fontWeight: 700,
            }}
          >
            Amplifying the greatest potential of creators.
          </Typography>
        </Grid>
        {useMobileView ? (
          <>
            <Grid item xs={12}>
              <Testimonials />
            </Grid>
          </>
        ): (
          <>
            <Grid item xs={3} />
            <Grid item xs={6} container justifyContent="center">
              <Testimonials />
            </Grid>
            <Grid item xs={3} />
          </>
        )}
        {useMobileView ? (
          <>
            <Grid
              item
              xs={12}
              container
              justifyContent="center"
              sx={{
                marginTop: '24px',
                paddingRight: '16px',
                paddingBottom: '16px',
              }}
            >
              <Typography 
                sx={{
                  fontSize: '20px',
                }}
                align="center"
              >
                <b>Plan <span style={{ color: 'red' }}>A</span> Media Group</b> is an inspired space helping filmmakers and content
                creators produce extraordinary work by providing expert feedback, creative consulting, coaching, and
                project-collaboration.
              </Typography>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={2} />
            <Grid
              item
              xs={8}
              container
              justifyContent="center"
              sx={{
                marginTop: '24px',
                paddingRight: '16px',
                paddingBottom: '16px',
              }}
            >
              <Typography 
                sx={{
                  fontSize: '1.5em',
                }}
                align="center"
              >
                <b>Plan <span style={{ color: 'red' }}>A</span> Media Group</b> is an inspired space helping filmmakers and content
                creators produce extraordinary work by providing expert feedback, creative consulting, coaching, and
                project-collaboration.
              </Typography>
            </Grid>
            <Grid item xs={2} />
          </>
        )}
        
        {!useMobileView && (
          <Grid item xs={3} />
        )}
        <Grid
          item
          xs={useMobileView ? 12: 6}
          sx={{
            paddingBottom: `${useMobileView ? '28px !important' : '32px !important'}`,
            paddingLeft: '8px !important'
          }}
          id="who"
        >
          <Who />
        </Grid>
        {!useMobileView && (
          <>
            <Grid item xs={3} />
            <Grid item xs={3} />
          </>
        )}
        <Grid
          item
          xs={useMobileView ? 12: 6}
          sx={{
            paddingBottom: `${useMobileView ? '28px !important' : '32px !important'}`,
            paddingLeft: '8px !important'
          }}
          id="group"
        >
          <Group />
        </Grid>
        {!useMobileView && (
          <>
            <Grid item xs={3} />
            <Grid item xs={3} />
          </>
        )}
        <Grid
          item
          xs={useMobileView ? 12: 6}
          sx={{
            paddingBottom: `${useMobileView ? '28px !important' : '32px !important'}`,
            paddingLeft: '8px !important'
          }}
          id="what"
        >
          <What />
        </Grid>
        {!useMobileView && (
          <>
            <Grid item xs={3} />
            <Grid item xs={3} />
          </>
        )}
        <Grid
          item
          xs={useMobileView ? 12: 6}
          sx={{
            paddingBottom: `${useMobileView ? '28px !important' : '32px !important'}`,
            paddingLeft: '8px !important'
          }}
          id="services"
        >
          <Services />
        </Grid>
        {!useMobileView && (
          <>
           <Grid item xs={3} />
           <Grid item xs={3} />
          </>
        )}
        <Grid item xs={useMobileView ? 12: 6} id="contact" sx={{ paddingLeft: '8px !important' }}>
          <Contact />
        </Grid>
        {!useMobileView && (
          <Grid item xs={3} />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        container
        justifyContent="center"
        sx={{
          paddingTop: '42px',
          paddingBottom: '24px',
        }}
      >
        <img src={mainLogo} alt="Plan A Media Group" />
      </Grid>
      <Grid
        item
        xs={12}
        container
        justifyContent="center"
      >
        <Typography
          sx={{
            fontSize: '1.5em',
            fontWeight: 700,
          }}
          align="center"
        >
          Plan <span style={{ color: 'red' }}>A</span>: Amplifying the greatest potential of creators and their projects.
        </Typography>
      </Grid>
      {showButton && (
        <div
          style={{
            position: 'fixed',
            zIndex: 99,
            right: 24,
            bottom: 36,
          }}
        >
          <IconButton
            sx={useMobileView ? backToTopBtnMobile : backToTopBtnDesktop}
            onClick={scrollToTop}
          >
            {useMobileView ? (
              <ArrowUpwardIcon sx={backToTopIconMobile} />
            ): (
              <ArrowUpwardIcon />
            )}
          </IconButton>
        </div>
      )}
    </>
  );
}
